import styled from 'styled-components';
import { colors } from 'Constants/Colors';
import { padding } from '@mui/system';
import { TextField } from '@mui/material';

export const PageContainer = styled.div`
  width: 93%;
  margin: auto;
`;

export const PermissionsGrid = styled.div`
  display: grid;
  margin: 2rem 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 2rem;
`;

export const StyledTextField = styled(TextField)`
  width: 25%;
  border: none;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  flex-basis: shrink;
  box-sizing: border-box;
  position: relative;
`;

export const Header = styled.div`
  padding: 2rem 0 0 2rem;
  display: flex;
  flex-direction: row;
  height: 20%;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 1rem;
`;

export const Body = styled.div`
  padding: 0 2rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  gap: 1rem;
  width: 100%;
  height: 30%;
  font-family: quicksand;
  margin-bottom: 1rem;
`;

export const FloatingClose = styled.div`
  position: absolute;
  top: 1rem;
  right: 2rem;
  color: ${colors.GRAY_DARK};
  cursor: pointer;
`;

export const ButtonContainer = styled.div`
  padding-top: 2rem;
  padding-bottom: 2rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 10%;
  width: 20%;
  gap: 1rem;
`;

export const ButtonContainer2 = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  height: 10%;
  gap: 1rem;
`;

export const acceptButton = {
  width: '40%',
  padding: '0.5rem 1rem',
  height: '100%',
  borderRadius: '0.5rem',
  background: colors.GREEN_LEAF,
};

export const disabledButton = {
  width: '40%',
  height: '100%',
  padding: '0.5rem 1rem',
  borderRadius: '0.5rem',
  background: colors.GRAY,
};

export const cancelButton = {
  border: `0.15rem solid ${colors.GREEN_LEAF}`,
  width: '40%',
  height: '100%',
  padding: '0.5rem 1rem',
  borderRadius: '0.5rem',
};

export const acceptButton2 = {
  padding: '0.75rem 2.5rem 0.75rem 2.5rem',
  height: '100%',
  borderRadius: '0.5rem',
  background: colors.GREEN_LEAF,
};

export const cancelButton2 = {
  border: `0.15rem solid ${colors.GREEN_LEAF}`,
  padding: '0.75rem 2.5rem 0.75rem 2.5rem',
  height: '100%',
  borderRadius: '0.5rem',
};

export const NameContainer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
`;

export const Info = styled.div`
  align-items: center;
  display: flex;
  gap: 0.5rem;
  background: #ecf9ffff;
  border-radius: 0.875rem;
  padding: 0.65rem;
  gap: 0.75rem;
`;

export const titleStyle = {
  fontSize: '1.25rem',
  fontWeight: 'bold',
  fontFamily: 'var(--app-font)',
  marginBottom: '0.25rem',
};

export const hrStyle = {
  // margin: '0',
  // border: '0',
  padding: '0',
  margin: '0',
  borderTop: '1px solid #c9c7c7',
  width: '100%',
};
